import {h, Component} from 'preact';
import {connect} from 'react-redux';
import reduce from '../reducers';
import * as actions from '../actions';
import { Fragment } from 'react';

import TextBar from './TextBar';
import ImageBar from './ImageBar';
import IllustrationBar from './IllustrationBar';
import ShapeBar from './ShapeBar';
import GroupBar from './GroupBar';
import FrameBar from './FrameBar';
import VideoFrameBar from './VideoFrameBar';
import MultiSelectBar from './MultiSelectBar';
import PageBar from './PageBar';
import PagesBar from './PagesBar';
import MenuObjectBar from './MenuObjectBar';
import LayoutGuideBar from "./LayoutGuideBar";
import QrCodeBar from './QrCodeBar';
import FramePreviewBar from './FramePreviewBar';

import {scrollRuler, rulerIsToggled} from "../canvas/page-ruler";
import store from "../store";
import { CloseOutlined } from '@ant-design/icons';
import Renderer from '../canvas/renderer';

export default @connect(reduce, actions)
class ContextBar extends Component {
  constructor() {
    super();
  }

  componentDidMount() {
  }

  onContextBarClick() {
    store.dispatch(actions.setIsMOEditModal(false));
  }

  mobileCloseContextBar() {
    Renderer.deselectAll();
    store.dispatch(actions.deselect());

    // if (store.getState().selectionType === 'pages') {
      store.dispatch(actions.setIsViewAllPages(false));
    // }
  }

  render(props, state) {
    if (rulerIsToggled()) {
      setTimeout(scrollRuler, 500);
    }

    const differentObjectMultiSelect = props.multiSelectType === 'none';
    const multiselect = props.isMultiSelect && props.$elements.length > 1;

    return props.hasSelection || store.getState().isViewAllPages ? <div id="context-bar" onClick={this.onContextBarClick}>
      {props.isMobileVersion && <div className="close-context-bar" onClick={this.mobileCloseContextBar}>
        <div className="border"/>
        <div className="cls-btn">
          <CloseOutlined/>
        </div>
      </div>}
      {multiselect && <MultiSelectBar/>}

      <Fragment>
        {!props.isMultiSelect && props.selectionType === 'menu-object' && <MenuObjectBar multiselect={multiselect}/>}
        {!props.isMultiSelect && props.selectionType === 'image' && <ImageBar multiselect={multiselect}/>}
        {!props.isMultiSelect && props.selectionType === 'qr-code' && <QrCodeBar multiselect={multiselect}/>}
        {!props.isMultiSelect && props.selectionType === 'frame' && <FrameBar multiselect={multiselect}/>}
        {!props.isMultiSelect && props.selectionType === 'video-frame' && <VideoFrameBar multiselect={multiselect}/>}
        {!props.isMultiSelect && props.selectionType === 'illustration' && <IllustrationBar multiselect={multiselect}/>}
        {!props.isMultiSelect && props.selectionType === 'shape' && <ShapeBar multiselect={multiselect}/>}
        {!props.isMultiSelect && props.selectionType === 'text' && <TextBar multiselect={multiselect}/>}
        {!props.isMultiSelect && props.selectionType === 'frame-preview' && <FramePreviewBar />}

        {!props.isMultiSelect && props.selectionType === 'group' && <GroupBar/>}
        {!props.isMultiSelect && props.selectionType === 'page' && <PageBar/>}
        {!props.isMultiSelect && props.selectionType === 'pages' && <PagesBar/>}
        {!props.isMultiSelect && props.isLayoutGuideToggled && <LayoutGuideBar/>}
      </Fragment>
    </div> : null;
  }
}
